import { OpenApiRemoteMethod, OpenApiRemoteMethodParameter } from 'eurogard-open-api-remote-method';
import { ProxyRemoteMethod } from 'eurogard-remote-method';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class CreateSubmitFormAdapter extends ProxyRemoteMethod<any, Record<string, any>, OpenApiRemoteMethodParameter> {

  constructor(
    @Inject(OpenApiRemoteMethod)
      remoteMethod: OpenApiRemoteMethod,
  ) {
    super(remoteMethod);
  }

  public transformParameters(value: Record<string, any>): OpenApiRemoteMethodParameter {
    return {
      requestBody: value,
    };
  }

}

export function CreateSubmitFormAdapterFactory(remoteMethod: OpenApiRemoteMethod) {
  return new CreateSubmitFormAdapter(remoteMethod);
}
